import { Link } from "react-router-dom";
import { faqs } from "@/mocks/manga";

export default function FaqPreview() {
  const items = faqs.slice(0, 4);
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">常见问题</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              阅读之前，你可能想知道
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于单行本卷数、全彩版本、番外收录与阅读方式等疑问，我们整理了常见解答。
              更多问题欢迎前往完整 FAQ 页面查看。
            </p>
            <Link
              to="/faq"
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-2.5 text-sm font-semibold whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
            >
              查看全部问题
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="space-y-3">
            {items.map((f) => (
              <details key={f.q} className="group rounded-2xl bg-background-100 p-5 open:bg-background-100">
                <summary className="flex cursor-pointer list-none items-center justify-between gap-3 text-sm font-semibold text-foreground-950">
                  {f.q}
                  <i className="ri-add-line text-primary-600 transition-transform group-open:rotate-45"></i>
                </summary>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{f.a}</p>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}